'use client';

import type { Point } from './types';

/**
 * @description generates an array of points from a DOMRect instance
 * starting from the top left corner and moving clockwise
 */
export function getPointsFromRectangle({
  top,
  right,
  bottom,
  left,
}: DOMRect): Point[] {
  return [
    { x: left, y: top },
    { x: right, y: top },
    { x: right, y: bottom },
    { x: left, y: bottom },
  ];
}
